import { Component, DestroyRef, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NAVIGATION_ITEMS, filtrarNavegacao } from '../../layouts/main-layout/navigation-items';
import { AcessoService } from '../../../core/acesso/acesso.service';
import { SideNavigationItemComponent } from '../side-navigation-item/side-navigation-item.component';

@Component({
  selector: 'app-side-navigation',
  standalone: true,
  imports: [NzIconModule, NzToolTipModule, SideNavigationItemComponent],
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.scss'
})
export class SideNavigationComponent {
  private readonly router = inject(Router);
  private readonly acesso = inject(AcessoService);
  protected readonly items = computed(() => filtrarNavegacao(NAVIGATION_ITEMS, this.acesso.contexto()));
  expanded = false;

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => (this.expanded = false));
  }
}
